<template>
  <div>
    <h1>面试管理</h1>
    <el-upload
      class="upload-demo"
      :action="apibase+'/upload_hr'"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :on-change="handleChange"
    >
      <el-button size="small" type="primary">上传岗位需求开始在线面试</el-button>
      <template #tip>
        <div class="el-upload__tip"></div>
      </template>
    </el-upload>
    <el-table :data="resumeList" style="width: 100%">
      <el-table-column prop="xbody" label="需求">
        <template #default="scope">
          <span v-if="scope.row.xbody.length <= 30">{{ scope.row.xbody }}</span>
          <span v-else>{{ scope.row.xbody.substring(0, 30) }}...</span>
          <div>
            Q1: {{ scope.row.item1_txt }}
          </div>
          <div>
            Q2: {{ scope.row.item2_txt }}
          </div>
          <div>
            Q3: {{ scope.row.item3_txt }}
          </div>
                </template>
      </el-table-column>
      <el-table-column  label="面试记录">
        <template #default="scope">
          <div v-if="scope.row.items.length==0">暂无</div>
          <div v-else>
              共{{ scope.row.items.length }}条，
              <div
               v-for="(item, index) in scope.row.items"
                  :key="index"
              >
              {{ item.created_at+'，总分：'+item.all_score+'/300，' }}
              <el-button @click="selectedView=scope.row,selectedItem=item,dialogVisible = true" >详</el-button>

              </div>

              
            </div>
          
        </template>
      </el-table-column>
      
      <el-table-column  label="面试记录">
        <template #default="scope">
          <!-- <div>{{ local+ '/s/view/'+scope.row.id }}</div>
          <div>
            <a target="_blank" :href="local+ '/s/view/'+scope.row.id">开始面试</a>
          </div> -->
          <div>
            <div class="qrcode-div" :id="scope.row.id"></div>
          </div>
        </template>
      </el-table-column>

    </el-table>
    <el-dialog v-model="dialogVisible" title="面试记录详情">
      <InterviewRecord v-if="selectedItem" :view="selectedView" :view_item="selectedItem" />
    </el-dialog>
  </div>

  
</template>

<script>
import { ElUpload, ElButton } from 'element-plus';
import { fetchData } from '@/api.js';
import InterviewRecord from '@/components/InterviewRecord.vue';
import QRCode from 'qrcodejs2';

export default {
  name: 'Interview',
  components: {
    ElUpload,
    ElButton,
    InterviewRecord,
  },
  data() {
    return {
      apibase: process.env.VUE_APP_API_BASE_URL,
      uploadStatus: '', // 上传状态提示文字
      resumeList: [], // 用于存储从后台获取的简历列表
      dialogVisible: false, // 控制弹窗显示
      selectedItem: null, // 选中的面试记录
      selectedView:false,
      local:location.origin
    };
  },
  methods: {
    handleChange(file) { // 添加 handleChange 方法
      if (file.status === 'uploading') {
        this.uploadStatus = '上传中，AI分析中';
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.uploadStatus = '文件已移除';
    },
    handlePreview(file) {
      console.log(file);
      this.uploadStatus = '预览文件: ' + file.name;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
      this.uploadStatus = '超出文件限制';
    },
    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${ file.name } ?`).then(() => {
        this.uploadStatus = '取消上传: ' + file.name;
      }).catch(() => {
        this.uploadStatus = '上传取消';
      });
    },
    handleUploadSuccess() { // 添加 handleUploadSuccess 方法
      this.uploadStatus = '上传成功，AI分析中';
      this.fetchResumes();
    },
    async fetchResumes() { // 从后台读取简历列表
      try {
        const data = await fetchData('interview_list');
        this.resumeList = data;
        this.uploadStatus = '';
        this.updateQr();
      } catch (error) {
        console.error('Error fetching resumes:', error);
      }
    },
    playAudio(audioSrc) {
      if (!audioSrc) {
        this.$message.warning('音频文件不存在');
        return;
      }
      const audio = new Audio(audioSrc);
      audio.play().catch(error => {
        console.error('播放音频失败:', error);
        this.$message.error('播放音频失败，请检查音频文件');
      });
    },
    pauseOtherAudios(event) {
      const audioElements = document.querySelectorAll('audio');
      audioElements.forEach(audio => {
        if (audio !== event.target) {
          audio.pause();
        }
      });
    },
    updateQr(){
      this.$nextTick(() => {
        document.querySelectorAll('.qrcode-div').forEach(element => {
          element.innerHTML='';
          // if (element &&!element.hasChildNodes()) {
            new QRCode(element, {
              text: this.local + '/s/view_chat/' + element.id,
              width: 130,
              height: 130
            });
          // }
        });
      });
    }
  },
  created() {
    this.fetchResumes(); // 组件加载时获取数据
  },
};
</script>

<style scoped>
.upload-demo {
  margin-bottom: 20px;
}
.upload-status {
  margin-top: 10px;
  color: #606266;
}
</style>